module.exports = __webpack_public_path__ + "img/13.26db0695.png";